module.exports = __webpack_public_path__ + "img/21.b8119347.svg";